import React from 'react';

const Card = ({ title, subtitle, action, children, className = '', glow = false }) => {
  return (
    <div className={`card ${glow ? 'card-glow' : ''} ${className}`}>
      {(title || action) && (
        <div className="card-header">
          <div>
            {title && <div className="card-title">{title}</div>}
            {subtitle && <div className="card-subtitle">{subtitle}</div>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
